import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_LD_TERMS'),
  ...asyncTypes('CREATE_LD_TERMS')
};

export default TYPES;
